export default "__VITE_ASSET__oJMYiNMG__"